import { REQUEST, SUCCESS, FAILURE } from "../actions";
import { INVOICES } from "../actions/invoice";

const initialState = {
  loading: false,
  invoices: [],
  adhoc: [],
  membership: [],
  error: "",
};

export const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVOICES[REQUEST]:
      return {
        ...state,
        loading: true,
      };
    case INVOICES[SUCCESS]:
      return {
        ...state,
        loading: false,
        adhoc: action.payload.adhoc,
        membership: action.payload.membershipType,
      };
    case INVOICES[FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
